<template>
  <div>
    <collapse title="Relación de los servicios con fondos públicos">
      <validation-provider
        v-if="!isReadOnly"
        v-slot="{ errors }"
        :custom-messages="{
          required: 'El campo es requerido.',
        }"
        rules="required"
      >
        <custom-text-area
          v-model="model"
          :count-classes="['d-block', 'small-counter']"
          :custom-error-msg="errors[0]"
          :error="errors[0]"
          label="Explicación de cómo los servicios a solicitar no reemplazan o sustituyen actividades que deban ser sufragadas con fondos estatales, locales o de otros programas federales; excepto que por disposición de una ley federal se indique lo contrario."
          :maxlength="10000"
          show-char-count
        />
      </validation-provider>
      <div v-else-if="isReadOnly" class="my-2">
        <div class="my-2">
          Explicación de cómo los servicios a solicitar no reemplazan o
          sustituyen actividades que deban ser sufragadas con fondos estatales,
          locales o de otros programas federales; excepto que por disposición de
          una ley federal se indique lo contrario.
        </div>
        <label class="data-label">
          {{ model | empty }}
        </label>
      </div>
    </collapse>
  </div>
</template>

<script>
import Collapse from '@/components/common/SimpleCollapse.vue';
import CustomTextArea from 'CustomTextArea';

export default {
  name: 'PublicFundsServices',
  components: {
    Collapse,
    CustomTextArea,
  },
  props: {
    value: {
      type: String,
      default: () => '',
    },
    isReadOnly: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
